import { render, staticRenderFns } from "./UnitWorkList.vue?vue&type=template&id=4d60ef55&scoped=true"
import script from "./UnitWorkList.vue?vue&type=script&lang=js"
export * from "./UnitWorkList.vue?vue&type=script&lang=js"
import style0 from "./UnitWorkList.vue?vue&type=style&index=0&id=4d60ef55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60ef55",
  null
  
)

export default component.exports